module.exports = __webpack_public_path__ + "static/mobile_touches-19464cab5835767d92ffefc24066cdb9.png";